import React from 'react';
import { Gift } from 'lucide-react';
const BonusCard = ({
  title,
  desc,
  image
}: {
  title: string;
  desc: string;
  image: string;
}) => {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div onClick={scrollToCheckout} className="bg-white rounded-xl overflow-hidden shadow-lg border border-[#E8D5D5] flex flex-col h-full transform transition-transform hover:-translate-y-1 duration-300 cursor-pointer" data-id="element-15">
      <div className="relative p-4 bg-gradient-to-b from-[#FDF8F3] to-white" data-id="element-16">
        <div className="absolute top-2 right-2 bg-[#9CAF88] text-white text-xs font-bold px-3 py-1 rounded-full z-10" data-id="element-17">
          GRATIS
        </div>
        <img src={image} alt={title} className="w-full h-48 object-contain mx-auto" data-id="element-18" />
      </div>
      <div className="p-6 flex-1 flex flex-col" data-id="element-19">
        <h3 className="font-bold text-lg text-[#2D3436] mb-2" data-id="element-20">{title}</h3>
        <p className="text-gray-600 text-sm" data-id="element-21">{desc}</p>
      </div>
    </div>;
};
export function Bonuses() {
  return <section className="py-16 px-4 bg-[#FDF8F3]" data-id="element-22">
      <div className="max-w-6xl mx-auto" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <div className="inline-flex items-center gap-2 bg-[#E8D5D5] px-4 py-2 rounded-full mb-4" data-id="element-25">
            <Gift size={18} className="text-[#2D3436]" data-id="element-26" />
            <span className="font-bold text-sm tracking-wide uppercase" data-id="element-27">
              Regalos Exclusivos
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D3436]" data-id="element-28">
            BONOS GRATIS POR EL DÍA DE HOY
          </h2>
          <p className="mt-4 text-gray-600" data-id="element-29">
            Incluidos con tu compra para potenciar tus resultados
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-30">
          <BonusCard title="Rutinas Express" desc="21 rutinas de Yoga diseñadas específicamente para encajar en tu día a día, sin importar cuán ocupada estés. 10-15 minutos, en casa, sin excusas." image="https://cdn.magicpatterns.com/uploads/9AHB5bY7Gc24wosfwkqhW4/ChatGPT_Image_28_ene_2026,_14_47_00.png" data-id="element-31" />
          <BonusCard title="Yoga Terapéutico" desc="Sesiones especiales enfocadas en el alivio físico y emocional para tu cuerpo y tu mente. Tu botiquín natural para el estrés y el dolor." image="https://cdn.magicpatterns.com/uploads/iLGo687amxE2tjczjra1st/ChatGPT_Image_28_ene_2026,_14_50_58.png" data-id="element-32" />
          <BonusCard title="Diario de Práctica (90 Días)" desc="Tu compañero por 90 días para transformar tu hábito y sostener tu motivación día a día. Registrá avances y construí el hábito desde la consciencia." image="https://cdn.magicpatterns.com/uploads/uQ7kxDjZkNGxhQo7Ewe4Dh/ChatGPT_Image_28_ene_2026,_15_08_17.png" data-id="element-33" />
        </div>
      </div>
    </section>;
}